<template>
  <div class="input-group input-group-sm color-input">
    <input type="color" class="form-control form-control-color" :value="modelValue || fallback"
           @input="$emit('update:modelValue', $event.target.value)" :title="modelValue || 'Default'">
    <input type="text" class="form-control font-monospace" :value="modelValue" maxlength="7"
           :placeholder="allowEmpty ? 'Default' : '#000000'" @change="onText($event.target.value)">
    <button v-if="allowEmpty && modelValue" type="button" class="btn btn-outline-secondary" title="Use default" @click="$emit('update:modelValue', '')">
      <i class="bi bi-x"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "ColorInput",

  emits: ['update:modelValue'],

  props: {
    modelValue: { type: String, default: '' },
    allowEmpty: { type: Boolean, default: false },
    fallback: { type: String, default: '#ffffff' },
  },

  methods: {
    onText(value) {
      let v = (value || '').trim()
      if (v && !v.startsWith('#')) v = '#' + v
      if (/^#[0-9a-f]{3}$/i.test(v)) v = '#' + v.slice(1).split('').map(c => c + c).join('')
      if (/^#[0-9a-f]{6}$/i.test(v)) this.$emit('update:modelValue', v.toLowerCase())
      else if (!v && this.allowEmpty) this.$emit('update:modelValue', '')
      else this.$forceUpdate()
    },
  },
}
</script>

<style scoped>
.color-input .form-control-color {
  max-width: 44px;
  padding: 2px;
}
</style>
